import { render, staticRenderFns } from "./industryMode.vue?vue&type=template&id=2f9f3c58&scoped=true&"
import script from "./industryMode.vue?vue&type=script&lang=js&"
export * from "./industryMode.vue?vue&type=script&lang=js&"
import style0 from "./industryMode.vue?vue&type=style&index=0&id=2f9f3c58&lang=scss&scoped=true&"
import style1 from "./industryMode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f3c58",
  null
  
)

export default component.exports